import { IObservable } from '~/rage/utils';
import { VarsService } from '../VarsService';
import { IRestrictionsService } from './restrictionsServiceTypes';

export class RestrictionsService implements IRestrictionsService {
	constructor(protected readonly vars: VarsService) {}

	public getMuteExpiresAt(): IObservable<number | null> {
		return this.vars.get('muteExpiresAt', null);
	}

	public isPlayerBanned(): IObservable<boolean> {
		return this.vars.get('playerBanned', false);
	}

	public isPlayerKicked(): IObservable<boolean> {
		return this.vars.get('playerKicked', false);
	}

	public getBanReason(): IObservable<string> {
		return this.vars.get('banReason', '');
	}

	public getKickReason(): IObservable<string> {
		return this.vars.get('kickReason', '');
	}

	public getBanExpiresAt(): IObservable<number | null> {
		return this.vars.get('banExpiresAt', null);
	}
}
